<button
  mat-flat-button
  [color]="color"
  [ngClass]="buttonClass + ' mat-mdc-button-size-' + size"
  [class.loading]="loading"
  [disabled]="disabled"
>
  @if (loading) {
    <div class="xi-loader-container__inline-overlay">
      <xi-animation [height]="75" [width]="75" [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!loading) {
    <ng-content></ng-content>
  }
</button>
